import { render, staticRenderFns } from "./navbar-user.vue?vue&type=template&id=3b36e1a4&"
import script from "./navbar-user.vue?vue&type=script&lang=js&"
export * from "./navbar-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports